<template>
    <tr>
        <td class="editor-content editor-label">Image Fit</td>
        <td class="editor-content">
            <select class="form-control editor-form editor-select" v-model="selectedComponent.objectFit">
                <option>none</option>
                <option>fill</option>
                <option>cover</option>
                <option>contain</option>
            </select>
        </td>
    </tr>
</template>

<script>
    export default {
        name: 'ImageFitSelector',
        props: ['selectedComponent'],
        data () {
            return {
                model: webase.model
            }
        }
    }
</script>

<style>

</style>
